//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const userRoutes = [
  {
    path: i18n.global.t('routes.user.userList'),
    name: Routes.USER_LIST,
    component: () => import('@/components/user/UserList.vue'),
    meta: {
      title: i18n.global.t('titles.user.userList'),
      active: 'user',
      roles: [Permissions.ROLE_USER_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.user.userCreate'),
    name: Routes.USER_CREATE,
    component: () => import('@/components/user/UserCreate.vue'),
    meta: {
      title: i18n.global.t('titles.user.userCreate'),
      active: 'user',
      roles: [Permissions.ROLE_USER_CREATE],
    },
  },
  {
    path: i18n.global.t('routes.user.userEdit'),
    name: Routes.USER_EDIT,
    component: () => import('@/components/user/UserEdit.vue'),
    meta: {
      title: i18n.global.t('titles.user.userEdit'),
      active: 'user',
      roles: [Permissions.ROLE_USER_EDIT],
    },
  },
  {
    path: i18n.global.t('routes.user.userProgress'),
    name: Routes.USER_PROGRESS,
    component: () => import('@/components/user/UserProgress.vue'),
    meta: {
      title: i18n.global.t('titles.user.userProgress'),
      active: 'user',
      roles: [Permissions.ROLE_USER_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.user.userDiary'),
    name: Routes.USER_DIARY,
    component: () => import('@/components/user/diary/UserDiary.vue'),
    meta: {
      title: i18n.global.t('titles.user.userDiary'),
      active: 'user',
      roles: [Permissions.ROLE_USER_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.user.userProfile'),
    name: Routes.USER_PROFILE,
    component: () => import('@/components/user/profile/UserProfile.vue'),
    meta: {
      title: i18n.global.t('titles.user.userProfile'),
      layout: 'flex',
    },
  },
  {
    path: i18n.global.t('routes.user.userModules'),
    name: Routes.USER_MODULES,
    component: () => import('@/components/user/module/UserModules.vue'),
    meta: {
      title: i18n.global.t('titles.user.userModules'),
      active: 'userModule',
      layout: 'user',
    },
  },
  {
    path: i18n.global.t('routes.user.userModuleShow'),
    name: Routes.USER_MODULE_SHOW,
    component: () => import('@/components/user/module/UserModuleShow.vue'),
    meta: {
      title: i18n.global.t('titles.user.userModuleShow'),
      active: 'userModule',
      layout: 'user',
    },
  },
  {
    path: i18n.global.t('routes.user.moduleChapterStepUserShow'),
    name: Routes.MODULE_CHAPTER_STEP_USER_SHOW,
    component: () => import('@/components/common/module/chapter/step/user/ModuleChapterStepUserShow.vue'),
    meta: {
      title: i18n.global.t('titles.user.moduleChapterStepUserShow'),
      active: 'userModule',
      layout: 'user',
    },
  },
  {
    path: i18n.global.t('routes.user.moduleChapterStepUserExam'),
    name: Routes.MODULE_CHAPTER_STEP_USER_EXAM,
    component: () => import('@/components/common/module/chapter/step/exam/ModuleChapterStepUserExam.vue'),
    meta: {
      title: i18n.global.t('titles.user.moduleChapterStepUserExam'),
      active: 'userModule',
      layout: 'user',
    },
  },
  {
    path: i18n.global.t('routes.user.userDashboard'),
    name: Routes.USER_DASHBOARD,
    component: () => import('@/components/user/UserDashboard.vue'),
    meta: {
      title: i18n.global.t('titles.user.userDashboard'),
      active: 'userDashboard',
      layout: 'user',
    },
  },
];
